import React from 'react'
import PropTypes from 'prop-types'
import { StickyContainer, Sticky } from 'react-sticky'

// import css from 'cape-style'
import StudentInfo from './StudentInfo'
import ShowInfo from './ShowInfo'
import ProgramList from './ProgramList'
import ImageStack from './ImageStack'
import ImageHeaderMobile from './ImageHeaderMobile'
import ImageStackMobile from './ImageStackMobile'
import NoImages from './NoImages'
import Logo from '../Logo/Logo'
import Page from '../Page'

import mgsLogo from '../../mgs2018logoarrow.svg'

import {
  Flex,
  ImageContainer,
  InfoContainer,
  Divider,
  Back,
  Loading,
  Left,
  Right,
  Wrapper,
  Box,
  Top,
} from './styles'

function StudentDetail({ closePopup, student }) {
  return (
    <Page shapeSize="half" shapePos="left" closePopup={closePopup} isInternal>
      <div>
        {/* <Back onClick={closePopup}>
          <Logo primary left logoSrc={mgsLogo} siteName="MICA Grad Show 2018" />
        </Back>
        {!student && <Loading className="flex loading">loading...</Loading>} */}
        {student && (
          <div>
            <Left>
              <div style={{ minHeight: '33vh' }} />
              <Wrapper>
                <Box shadow>
                  <StickyContainer>
                    <Sticky>
                      {({ style }) => (
                        <div style={style}>
                          <Top>Info</Top>
                        </div>
                      )}
                    </Sticky>
                    <InfoContainer>
                      <StudentInfo {...student} />
                      {/* <Divider /> */}
                    </InfoContainer>
                  </StickyContainer>
                </Box>
              </Wrapper>

              <div style={{ minHeight: '3rem' }} />

              <Wrapper>
                <Box shadow align="flex-end">
                  <StickyContainer>
                    <Sticky>
                      {({ style }) => (
                        <div style={style}>
                          <Top>Exhibition</Top>
                        </div>
                      )}
                    </Sticky>
                    <InfoContainer>{student.show && <ShowInfo {...student.show} />}</InfoContainer>
                  </StickyContainer>

                  {/* {student.art && student.art.length > 0 && (
                      <ImageStackMobile collection={student.art} />
                    )} */}
                  <StickyContainer>
                    <Sticky>
                      {({ style }) => (
                        <div style={style}>
                          <Top bt>Program</Top>
                        </div>
                      )}
                    </Sticky>
                    <InfoContainer>
                      <ProgramList {...student.program} />
                    </InfoContainer>
                  </StickyContainer>
                </Box>
              </Wrapper>

              <div style={{ minHeight: '3rem' }} />
            </Left>
            <Right>
              <ImageContainer>
                {student.art && student.art.length > 0 && <ImageStack collection={student.art} />}
                {/* {student.art && student.art.length > 0 && (
                  <ImageHeaderMobile collection={student.art} />
                )} */}
                {console.log(student.art)}
                {!student.art && <NoImages />}
              </ImageContainer>
            </Right>
          </div>
        )}
      </div>
      <div style={{ minHeight: '33vh' }} />
    </Page>
  )
}

StudentDetail.propTypes = {
  closePopup: PropTypes.func.isRequired,
  student: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
}
StudentDetail.defaultProps = {
  student: null,
}
export default StudentDetail
